module.exports = __webpack_public_path__ + "img/feedback@2x.38528f35.png";